<script lang="ts">
	import type { Component } from 'svelte';
	import type { ClassValue } from 'svelte/elements';

	const { text, Icon, classes }: { text?: string; Icon?: Component; classes?: ClassValue } = $props();
</script>

<span
	class="inline-flex items-center gap-1.5 rounded-full bg-black/42 px-2.5 py-1 text-xs font-semibold tracking-wide text-white backdrop-blur-xl {classes}"
>
	{#if Icon}<Icon class="h-3 w-3 opacity-90" />{/if}
	{#if text}{text}{/if}
</span>
